module.exports = __webpack_public_path__ + "img/4.14bbf497.jpg";